export default "__VITE_ASSET__CKP9Gmbs__"